export default "__VITE_ASSET__3z_$vGo6__"